/**
 * SFDC Community API
 * # Summary Elisa B2B API for an administrator of a company to query and modify the company information.  # Usage This API is used in the `https://yrityksille.elisa.fi/omaelisa` pages, but it is possible to later on expose this documentation publicly and make the endpoint queryable via external clients.  # Identifiers All entities in the API have a globally unique, internal identifier field named with the format [object_type]Id, e.g. `invoiceId`, which is also used in some of the API endpoint urls, e.g. `/api/v1/selfservice/invoices/{invoiceId}`. This value is not meaningful to the end user but is only used as an internally in the API.  Most entities also have a displayable identifier named in the format [object_type]DisplayId. This value can and should be shown to the end user, as it is also printed in relevant documents. It is also used in some of the public URLs, e.g. `https://yrityksille.elisa.fi/omaelisa/laskut/{invoiceDisplayId}`. Because of the user might land directly into a URL of a single entity with a display id, some of the API endpoints here also support querying via the display id, e.g. `/api/v1/selfservice/invoices?invoiceDisplayId={invoiceDisplayId}`.  The reason for using two identifiers instead of only one display id, is to make sure that every object will always have exactly one REST API URL that will never collide with another. While collisions of display ids should not happen in production, the id fields are guaranteed to be unique even across different test environments. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Contract { 
    /**
     * Contract number of the contract, to be shown to user. Mapped to Contract.ContractNumber object in SFDC
     */
    contractNumber: string;
    /**
     * Contract name of the contract, to be shown to user. Mapped to Contract.Name object in SFDC
     */
    contractName: string;
    /**
     * Status of contract in salesforce. Mapped to Contract.Status object in SFDC
     */
    contractStatus: Contract.ContractStatusEnum;
    /**
     * Unix timestamp of the start date of contract. Mapped to Contract.StartDate object in SFDC
     */
    contractStartDate?: number;
    /**
     * Unix timestamp creation date of contract
     */
    created?: number;
    /**
     * Unix timestamp of last modified date of contract
     */
    lastModified?: number;
    /**
     * Indicates whether or not any support case for termination request is already raised and pending
     */
    pendingTermination?: boolean;
    /**
     * Account master id of the account for which the contract belongs to. SFDC: Account.MDM_Id__c
     */
    accountMasterId?: string;
}
export namespace Contract {
    export type ContractStatusEnum = 'ACTIVATED' | 'TERMINATED';
    export const ContractStatusEnum = {
        ACTIVATED: 'ACTIVATED' as ContractStatusEnum,
        TERMINATED: 'TERMINATED' as ContractStatusEnum
    };
}


